import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  CrmFieldOptionsService,
  CrmFiltersService,
  CrmFormService,
  ContactService,
  ActivityService,
  CompanyService,
  CrmObjectService,
  ListObjectsTableService,
  CRMTrackingService,
  TranslateByObjectTypeService,
  CrmAssociationService,
  TaskTableCustomizationService,
  CrmTableStateService,
  ActivityObjectService,
  PreviewObjectService,
  DefaultAssociationActionsService,
  CompanyProfileCardsPanelService,
  CompanyTableCustomizationService,
  ContactTableCustomizationService,
  CrmFieldService,
  PAGE_ROUTES,
  TranslationModule,
  RendererSelectorService,
  AutocompleteService,
  UpdaterService,
  ValidatorFactoryService,
  CompanyFiltersService,
  ActivityAssigneeService,
  RestrictedGroupService,
  CompanyBatchGetterService,
} from '@galaxy/crm/static';
import { BulkImportStepperService } from './bulk-import/bulk-import-stepper.service';
import { FieldMappingService } from './bulk-import/field-mapping-step/field-mapping.service';
import { CsvParserService } from './bulk-import/file-upload-step/csv-parser.service';
import { GoogleMapsModule } from '@angular/google-maps';
import { ContactProfileCardsPanelService } from './crm-components/profile/profile-cards-panel/contact-profile-cards-panel.service';
import { PermissionsGuard } from './permissions-guard.service';

import { CompanyAdminNotesCardComponent } from './crm-components/profile/profile-cards-panel/company-to-contact-associations/company-admin-notes-associations-card/company-admin-notes-card.component';
export { CompanyAdminNotesCardComponent };

import { CompanyOpportunitiesCardComponent } from './crm-components/profile/profile-cards-panel/company-to-contact-associations/company-opportunities-associations-card/company-opportunities-card.component';
export { CompanyOpportunitiesCardComponent };

import { CompanyOrdersCardComponent } from './crm-components/profile/profile-cards-panel/company-to-contact-associations/company-orders-associations-card/company-orders-card.component';
export { CompanyOrdersCardComponent };

import { CompanyPrioritiesCardComponent } from './crm-components/profile/profile-cards-panel/company-to-contact-associations/company-priorities-associations-card/company-priorities-card.component';
export { CompanyPrioritiesCardComponent };

import { CompanyReportsCardComponent } from './crm-components/profile/profile-cards-panel/company-to-contact-associations/company-reports-associations-card/company-reports-card.component';
export { CompanyReportsCardComponent };

import { CompanyUtmAttributesCardComponent } from './crm-components/profile/profile-cards-panel/company-to-contact-associations/company-UTM-attributes-associations-card/company-utm-attributes-card.component';
export { CompanyUtmAttributesCardComponent };

const CRM_ROUTES: Routes = [
  {
    path: '',
    redirectTo: `${PAGE_ROUTES.CONTACT.ROOT}/${PAGE_ROUTES.CONTACT.SUBROUTES.LIST}`,
    pathMatch: 'full',
  },
  {
    path: PAGE_ROUTES.CONTACT.ROOT,
    loadChildren: () => import('./contact/contact.module').then((m) => m.CrmContactModule),
    canActivate: [PermissionsGuard],
    data: { objectType: 'contacts', pageId: 'crm' }, // pageId is the Atlas sidebar navigation link ID used in the business app
  },
  {
    path: PAGE_ROUTES.COMPANY.ROOT,
    loadChildren: () => import('./company/company.module').then((m) => m.CrmCompanyModule),
    canActivate: [PermissionsGuard],
    data: { objectType: 'companies', pageId: 'nav-crm-companies' }, // pageId is the Atlas sidebar navigation link ID used in the business app
  },
  {
    path: PAGE_ROUTES.TASK.ROOT,
    loadChildren: () => import('./activity/task/task.module').then((m) => m.CrmTaskModule),
    canActivate: [PermissionsGuard],
    data: { objectType: 'activities' },
  },
  {
    path: PAGE_ROUTES.PERMISSION_REQUIRED,
    loadComponent: () =>
      import('./crm-components/permission-required/permission-required.component').then(
        (m) => m.PermissionRequiredComponent,
      ),
  },
  {
    path: '**',
    loadComponent: () => import('./page-not-found.component').then((m) => m.CrmPageNotFoundComponent),
  },
];

@NgModule({
  imports: [RouterModule.forChild(CRM_ROUTES), TranslationModule, GoogleMapsModule],
  exports: [RouterModule],
  providers: [
    BulkImportStepperService,
    FieldMappingService,
    CsvParserService,
    CrmFieldOptionsService,
    CrmFiltersService,
    CrmFormService,
    ListObjectsTableService,
    ActivityObjectService,
    ContactService,
    CompanyService,
    CrmObjectService,
    CompanyBatchGetterService,
    CrmAssociationService,
    CRMTrackingService,
    CrmFieldService,
    ActivityService,
    ContactProfileCardsPanelService,
    CompanyProfileCardsPanelService,
    TranslateByObjectTypeService,
    RendererSelectorService,
    AutocompleteService,
    UpdaterService,
    ValidatorFactoryService,
    RestrictedGroupService,
    ContactTableCustomizationService,
    CompanyTableCustomizationService,
    TaskTableCustomizationService,
    CrmTableStateService,
    PreviewObjectService,
    DefaultAssociationActionsService,
    CompanyFiltersService,
    ActivityAssigneeService,
    PermissionsGuard,
  ],
})
export class CrmModule {}
